import { Module } from 'vuex'
import { state } from './state'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { RootState } from 'store'
import { ApprovalGroupState } from './types'

export const approvalGroup: Module<ApprovalGroupState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

